class CustomFooterMobileAccordion extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.componentEventHandler.bind(this));
  }

  componentEventHandler(event) {
    const accordionBlock = event.target.closest(
      ".footer-mobile-accordion-block"
    );
    if (!accordionBlock) return;
    const isOpen = accordionBlock.dataset.accordionBlockOpen === "true";
    if (isOpen) {
      accordionBlock.dataset.accordionBlockOpen = false;
    } else {
      this.resetAccordionBlocksState();
      accordionBlock.dataset.accordionBlockOpen = true;
    }
  }

  resetAccordionBlocksState() {
    this.querySelectorAll(".footer-mobile-accordion-block").forEach(
      (el) => (el.dataset.accordionBlockOpen = false)
    );
  }
}

customElements.define(
  "custom-footer-mobile-accordion",
  CustomFooterMobileAccordion
);
